<template>
  <o-view>
    <o-nav-bar :has-back-button="true" title="Fiets" />
    <o-map :is-large="true" :markers="markers" />
    <o-tabs
      :items="[
        { label: 'Tickets', isSelected: true },
        { label: 'Abonnementen' }
      ]"
    />
    <o-block-list>
      <o-list-item
        icon="brands/bluebike"
        icon-style="logo"
        label="Blue-bike"
        link="/sales/bike/bluebike"
      />
      <o-list-item icon="brands/velo" icon-style="logo" label="Velo" />
    </o-block-list>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'
import OTabs from '@/components/base/OTabs.vue'

export default {
  name: 'Bike',
  components: {
    OTabs,
    OMap
  },
  data() {
    return {
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'velo',
          title: 'Velo A',
          link: 'sales/bike/velo'
        },
        {
          coordinates: [3.723, 51.053],
          type: 'velo',
          title: 'Velo B',
          link: 'sales/bike/velo'
        },
        {
          coordinates: [3.72, 51.055],
          type: 'bluebike',
          title: 'Bluebike Gent',
          link: 'sales/bike/bluebike'
        }
      ]
    }
  }
}
</script>
